import { UploadOutlined } from '@ant-design/icons';
import React from 'react';
import { useParams } from 'react-router';
import GlobalButton from 'src/components/Antd/Button/Button';
import Export, { EnumScope } from 'src/constrains/Export/Export1';
import ModalHOC from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { CustomerListCommonContext } from 'src/pages/CustomerDatabaseConfig/CustomerList';
import { customerExport, subscriberExport } from 'src/request/customer/list';
import { convertRes2Blob } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EType } from '../../tools';
import css from './css.module.less';
const _Export = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { customerDatabaseUuid }: any = useParams();
  const { exportConfig } = React.useContext(CustomerListCommonContext);
  const { selectedUuids, selectAll, currentPageUuids, query } = exportConfig;
  // console.log('exportConfig', exportConfig);
  const { tabName, modalOp, disabled } = props;
  console.log('export - query', query);
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const scopeDic = {
    [EnumScope.Current]: {
      label: getI18n('customerList.export.currentPage'),
      value: EnumScope.Current,
      disable: !currentPageUuids.length,
    },
    [EnumScope.All]: {
      label: getI18n('customerList.export.allCustomers'),
      value: EnumScope.All,
    },
    [EnumScope.Selected]: {
      label: getI18n('customerList.export.selectedCustomers'),
      value: EnumScope.Selected,
      disable: !selectedUuids.length,
    },
  };
  const handleOnExport = (o) => {
    if (tabName === EType.Subscriber) {
      handleOnSubExport(o);
    } else {
      handleOnCustomerExport(o);
    }
  };

  const handleOnSubExport = (o) => {
    const { format, scope } = o;
    const obj = {
      scope,
      format,
      uuids: [],
    };
    if (scope === EnumScope.All) {
    } else if (scope === EnumScope.Current) {
      obj.uuids = currentPageUuids;
    } else if (scope === EnumScope.Selected) {
      obj.uuids = selectedUuids;
    } else {
      return;
    }
    subscriberExport(customerDatabaseUuid, obj)
      .then((res) => {
        try {
          convertRes2Blob(res);
          msg.success(getI18n('customerList.export.subscribers_export'));
        } catch (e) {
          console.warn(e);
          msg.error(e);
        }
      })
      .then(() => {
        onModalCancel();
      });
  };

  const handleOnCustomerExport = (o) => {
    const { format, scope } = o;
    const obj = {
      tabName,
      exportFormat: format,
      selectionType: null,
      customerUuids: [],
      query,
    };

    if (scope === EnumScope.All) {
      obj.selectionType = EnumScope.All;
    } else if (scope === EnumScope.Current) {
      obj.selectionType = EnumScope.Selected;
      obj.customerUuids = currentPageUuids;
    } else if (scope === EnumScope.Selected) {
      obj.selectionType = selectAll ? EnumScope.All : EnumScope.Selected;
      obj.customerUuids = selectedUuids;
    } else {
      return;
    }
    customerExport(customerDatabaseUuid, obj)
      .then((res): any => {
        try {
          convertRes2Blob(res);
          msg.success(getI18n('customerList.export.customers_export'));
        } catch (e) {
          console.warn(e);
          msg.error(e);
        }
      })
      .then(() => {
        onModalCancel();
      });
  };

  return (
    <GlobalButton
      type='text'
      className={css.layoutRightBtn}
      onClick={() => {
        setShowModal(true);
        setModalContent(
          <Export
            scopeList={[EnumScope.All, EnumScope.Current, EnumScope.Selected]}
            scopeDic={scopeDic}
            //   currentUuid={[productUuid]}
            onCancel={onModalCancel}
            onExport={handleOnExport}
          />,
        );
        setModalTitle(getI18n('general.export'));
      }}
      icon={<UploadOutlined />}
      disabled={disabled}>
      {getI18n('general.export')}
    </GlobalButton>
  );
};
export default ModalHOC(_Export);
